import React, {useState} from "react";
import {createPortal} from "react-dom";
import {IoIosDocument, IoLogoLinkedin, IoMdMail} from "react-icons/io";
import {TbBrandGithubFilled} from "react-icons/tb";
import {HiOutlineArrowDownTray, HiOutlineArrowTopRightOnSquare} from "react-icons/hi2";
import {Lightbox} from "./lightbox";
import {PdfPage} from "./pdfPage";
import {lite} from "../lite";
// served from public/ at a fixed URL, so the static fallback in index.html can link it too
const CV = "/CV.pdf";

interface LinksProps {
    className?: string
}

export function Links({className}: LinksProps) {
    const [cvOpen, setCvOpen] = useState(false);

    // The CV opens in the viewer; a modified click (new tab/window, download)
    // and lite mode (pdf.js is a big download) go straight to the PDF.
    const openCv = (e: React.MouseEvent) => {
        if (lite || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
        e.preventDefault();
        setCvOpen(true);
    };

    return (
        <div className={className} id={"links"}>
            <a className={"button"} href={CV} target="_blank" rel="noopener noreferrer" onClick={openCv}><IoIosDocument/> CV</a>
            <a className={"button"} href="mailto:noureldinesamehelfangary@gmail.com"><IoMdMail/> Email</a>
            <a className={"button"} href="https://github.com/nour2063" target="_blank" rel="noopener noreferrer"><TbBrandGithubFilled/> GitHub</a>
            <a className={"button"} href="https://www.linkedin.com/in/nour-elfangary/" target="_blank" rel="noopener noreferrer"><IoLogoLinkedin/> LinkedIn</a>
            {/* in <body>: the links sit inside a backdrop-filtered panel, which
                would otherwise become the fixed-position lightbox's frame */}
            {cvOpen && createPortal(
                <Lightbox
                    count={1}
                    index={0}
                    renderSlide={() => <PdfPage src={CV} title="Nour Elfangary's CV"/>}
                    slideKey={() => CV}
                    onClose={() => setCvOpen(false)}
                    maxZoom={3}
                    zoomToggle={false}
                    actions={<>
                        <a className="lightbox-action" href={CV} target="_blank" rel="noopener noreferrer">
                            <HiOutlineArrowTopRightOnSquare/> Open PDF
                        </a>
                        <a className="lightbox-action primary" href={CV} download="Nour-Elfangary-CV.pdf">
                            <HiOutlineArrowDownTray/> Download
                        </a>
                    </>}
                />,
                document.body,
            )}
        </div>
    );
}
